import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    DeleteAlarmGroupRequest,
    SaveStationAlarmsRequest,
} from "modules/common/components/Alarms/Form/utils/schemas/AlarmPayloadSchema";
import { IUserAlarmsResponse } from "modules/common/components/Alarms/types/AlarmModels";
import { toast } from "react-toastify";
import { createAuthService } from "services/serviceFactory";

const iotAuthService = createAuthService("iot");
const iotBase = "/iot/";
const queryKey = ["iot", "alarms"];

export const useAlarmsForUser = (isEnabled: boolean = true) => {
    const results = useQuery({
        queryKey,
        queryFn: async () => {
            const response = await iotAuthService.get<IUserAlarmsResponse>(
                `${iotBase}Alarms/GetAlarmsByUserIdAsync`
            );

            return response.data;
        },
        enabled: isEnabled,
    });

    const alarmsQuery = results;

    return {
        alarmsQuery,

        isLoading: results.isLoading,
        isError: results.isError,

        alarmGroups: alarmsQuery.data?.groups ?? null,
        userAlarmsResponse: alarmsQuery.data ?? null,
    };
};

export const useAlarmGroupsMutations = () => {
    const qc = useQueryClient();

    const save = useMutation(
        async (req: SaveStationAlarmsRequest) =>
            await iotAuthService.post(`${iotBase}Alarms/SaveStationAlarmsAsync`, req),
        {
            onSuccess: () => {
                qc.invalidateQueries(queryKey);
                toast.success("Grupa alarma je uspješno spremljena.");
            },
        }
    );

    const deleteAlarmGroup = useMutation(
        async (req: DeleteAlarmGroupRequest) =>
            await iotAuthService.delete(`${iotBase}Alarms/DeleteAlarmGroupAsync/${req.id}`),
        {
            onSuccess: () => {
                qc.invalidateQueries(queryKey);
                toast.success("Grupa alarma uspješno obrisana.");
            },
        }
    );

    return { save, deleteAlarmGroup };
};

export const useUpdateAlarmNotificationSeenAt = () => {
    return useMutation({
        mutationFn: async (alarmNotificationId: string) => {
            const response = await iotAuthService.put(
                `${iotBase}Alarms/UpdateAlarmNotificationSeenAtAsync/${alarmNotificationId}`
            );
            return response.data;
        },
    });
};
